import { colors } from 'shared/styles/colors'
import dimensions from 'shared/styles/dimensions'
import styled, { css } from 'styled-components'

const { componentHeight } = dimensions

type TContainer = {
  disabled?: boolean
}

export const Container = styled.div<TContainer>`
  select {
    width: 100%;
    max-height: ${componentHeight.large}px;

    border: 1px solid ${colors.grayLight};
    border-radius: 4px;

    padding: 12px 10px;

    font-weight: 400;
    font-size: 12px;

    margin: 10px 0px;

    > option:first-child {
      color: ${colors.grayDark};
    }

    ${props =>
      props.disabled &&
      css`
        pointer-events: none;
        background-color: ${colors.grayLight};
        color: ${colors.grayDark};
      `}
  }
`

export const ErrorMessage = styled.div`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: normal;
  color: ${colors.red};
  padding-right: 5px;
`
